module.exports = "//static.hsappstatic.net/visitor-ui-component-library/static-1.1841/img/default-avatar.png"